import { DateUtils } from '@brunommsilva/react-foundations';
import { SimpleCard } from '@brunommsilva/react-foundations';
import { useTheme } from '@brunommsilva/react-foundations';
import { Box, Skeleton } from '@mui/material';
import { useTranslation } from 'react-i18next';

import Cashflow from '../../models/cashflows/cashflow';
import BarChart from '../charts/bar-chart';

interface Props {
  cashflows: Cashflow[];
  isLoading: boolean;
}

const CashflowsChart = ({ cashflows, isLoading }: Props) => {
  const { t } = useTranslation();
  const { theme } = useTheme();

  const renderBalances = () => {
    if (isLoading) {
      return (
        <Box sx={{ height: 400, width: '100%', p: 2 }}>
          <Skeleton variant="rounded" width="100%" height="100%" />
        </Box>
      );
    }
    const months = cashflows.map(({ month }) =>
      DateUtils.formatMonth(month, 'short')
    );
    const incomes = cashflows.map(({ income }) => income);
    const revenues = cashflows.map(({ revenue }) => revenue);
    const expenses = cashflows.map(({ expenses }) => expenses);

    const values = [
      {
        label: t('EXPENSES'),
        values: expenses,
        colors: [theme.palette.error.main],
        type: 'bar' as const,
      },
      {
        label: t('INCOME'),
        values: revenues,
        colors: [theme.palette.success.main],
        type: 'bar' as const,
      },
      {
        label: t('NET_RESULT'),
        values: incomes,
        colors: [theme.palette.info.main],
        type: 'line' as const,
      },
    ];

    return (
      <Box sx={{ height: 400, width: '100%' }}>
        <BarChart labels={months} series={values} />
      </Box>
    );
  };

  return (
    <SimpleCard title={t('CASHFLOWS_CARD_TITLE')} content={renderBalances()} />
  );
};

export default CashflowsChart;
